module.exports = __webpack_public_path__ + "static/media/logoK.16369e96.png";